import React from 'react';
import { object,bool,func,string ,node} from 'prop-types';
import Expander from '../../atoms/Expander/index';
import {Panel} from '../../atoms/Panel/index';
import {QuizSentence} from '../QuizSentence';
import ReactMarkdown from 'react-markdown';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import {Label,YellowLabel,BlueLabel,RedLabel} from '../../atoms/Label/index';
import style from './style';

const ScorePoint = ({score,t}) =>{
	const point = score.passed / score.questionCount;
	const scoreTxt = t('play-quiz.Score',{passed:score.passed,questionCount:score.questionCount});
	let rendered = <BlueLabel>{scoreTxt}</BlueLabel>;
	if(point < 0.5) rendered =  <RedLabel>{scoreTxt}</RedLabel>;
	else if(point < 0.7) rendered =  <YellowLabel>{scoreTxt}</YellowLabel>;
	return <style.ScorePointWrapper>{rendered}</style.ScorePointWrapper>;
};
ScorePoint.propTypes = {
	score:object.isRequired,
	t:func.isRequired
};

const Result = ({isTrue, onClick,t}) => {
	const result =  isTrue ? 
		<style.OKLabel onClick={onClick}>{'OK'}</style.OKLabel> :
		<style.NGLabel onClick={onClick}>{'NG'}</style.NGLabel>;
	return (
		<React.Fragment>
			<Label>{t('play-quiz.Result')} : </Label>
			{result}
		</React.Fragment>);
};

Result.propTypes = {
	isTrue:bool.isRequired,
	onClick:func,
	t:func.isRequired
};

const QuestionResult = ({questionResult,label,t}) =>{
	const LabelStyle = questionResult.result ? style.AnswerLabel : style.NGLabel;
	return (
		<div>
			<Label>
				{label}
			</Label>
			<Panel>
				<style.AnswerDetailPanel>
					{t('play-quiz.Expected')}:<LabelStyle>{questionResult.expected}</LabelStyle>
				</style.AnswerDetailPanel>
				<style.AnswerDetailPanel>
					{t('play-quiz.YourAnswer')}:<LabelStyle>{questionResult.actual}</LabelStyle>
				</style.AnswerDetailPanel>
			</Panel>
		</div>
	);
};
	

QuestionResult.propTypes = {
	questionResult:object.isRequired,
	label:string,
	t:func.isRequired
};

const PartResult = ({partResult,questionResultsComponent,label,t})=>{
	return (
		<div>
			<style.PartResult>
				{label}
			</style.PartResult>
			<Expander isOpen={false} 
				renderAtClosed={({onClick})=>
					<div>
						<Result t={t} isTrue={partResult.result} onClick={onClick} />
					</div>}
				renderAtExpanded={({onClick})=>
					<div>
						<Result t={t} isTrue={partResult.result} onClick={onClick} />
						<Panel>
							<div>
								<ReactMarkdown
									source={partResult.question}
									renderers={{
										text: function Renderer(props) {
											return (
												<QuizSentence 
													content={props.children}
													onAnnotation={(answer,index) => {
														return index + 1;
													}}
												/>
											);
										}
									}}
								>
								</ReactMarkdown>
								
							</div>
							{questionResultsComponent}
					
							{partResult.explanation && (
								<style.Explanation>
									<Label>
										{t('play-quiz.Explanation')}
									</Label>
								
									<ReactMarkdown
										source={partResult.explanation}
										renderers={{
											text: function Renderer(props) {
												return <div>
													{props.children}
												</div>;
											}
										}}
									>
									</ReactMarkdown>
								
								</style.Explanation>
							)}
						</Panel>
					</div>}
			/>
		</div>
	);
};

PartResult.propTypes = {
	partResult:object.isRequired,
	questionResultsComponent:node,
	label:string,
	t:func.isRequired
};

function Score({score,t}) {
	const partsResultsComponent = score.results.map((partResult,index)=>{
		const questionResultsComponent = partResult.values&&partResult.values.map((questionResult,index)=>{
			return <QuestionResult 
				t={t}
				key={questionResult+index}
				questionResult={questionResult} 
				label={'No.' + (index+1) + ':'}
			/>;
		});
		return <PartResult 
			t={t}
			key={partResult+index}
			partResult={partResult}
			questionResultsComponent={questionResultsComponent}
			label={'No.' + (index+1) + ':'}
		/>;
	});
	return (
		<div>
			<style.ScoreWrapper>
				<Label>{t('play-quiz.YourScore')} : </Label>
				<ScorePoint t={t} score={score}/>
			</style.ScoreWrapper>
			<hr/>
			{partsResultsComponent}
		</div>
	);
}
Score.propTypes = {
	score:object,
	t : func.isRequired
};

export default withNamespaces()(Score);